import { numberToWords } from '@persian-tools/persian-tools';
import cs from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { useMemo } from 'react';
import { Button } from '@/DesignSystem/Component';
import useIsLandscape from '@/DesignSystem/Hook/useIsLandscape';
import { IconAngleRight } from '@/Module/Icon';
import { selectedLessonSectionSelector } from '@/Module/Lesson/Store/Selector/selectedLessonSectionSelector';
import { useAppSelector } from '@/Module/Store/Hook';
import { prepareTeacherUrl } from '@/Module/Teacher/Helper';
const LessonDetailHeader: FC = () => {
  const router = useRouter();
  const lessonSection = useAppSelector(selectedLessonSectionSelector);
  const teacher = useAppSelector(state => state.lessonSection.lessonSectionTeacher);
  const isLandscape = useIsLandscape();
  const lessonTitle = useMemo(() => {
    if (!lessonSection?.sortOrder) return '';
    try {
      return numberToWords(lessonSection?.sortOrder, {
        ordinal: true
      }) as string;
    } catch {
      return '';
    }
  }, [lessonSection?.sortOrder]);
  const onBackClick = () => {
    router.back();
  };
  if (!lessonSection) return null;
  return <div className={cs('mb-2 flex items-stretch md:gap-5', isLandscape && 'order-[0]')} data-sentry-component="LessonDetailHeader" data-sentry-source-file="LessonDetailHeader.tsx">
      <div className="flex items-center">
        <Button variant="text" color="orangeDark" onClick={onBackClick} iconButton data-sentry-element="Button" data-sentry-source-file="LessonDetailHeader.tsx">
          <IconAngleRight data-sentry-element="IconAngleRight" data-sentry-source-file="LessonDetailHeader.tsx" />
        </Button>
      </div>
      <div className="flex flex-col items-start gap-2 ">
        <div className="text-base sm:text-xl lg:text-4xl">
          <span className="ml-2 inline">قسمت {lessonTitle}:</span>
          <h1 className="inline font-bold">{lessonSection.name}</h1>
        </div>

        {teacher && <div className="flex items-center gap-1 text-sm sm:text-lg">
            <span>مدرس:</span>
            <Link className="font-bold text-blue-600 hover:underline" href={prepareTeacherUrl(teacher)} target="_blank">
              {teacher.person.name} {teacher.person.family}
            </Link>
          </div>}
      </div>
    </div>;
};
export default LessonDetailHeader;